import { HGenerateFileData } from "@rf-l1/file/helpers/create-file-data";

import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { C_PERTENECE } from "../../../components/property-form/septions/property-steps/documentation-step/validations-project/validation-documents/models/acoprivi.const";
import {
  C_YES_AND_NOT,
  O_YES_AND_NOT
} from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { A_STATUS_TRUST } from "../../../components/property-form/septions/property-steps/documentation-step/validations-project/validation-documents/models/trust.const";
import { O_TRUST_ENTITY } from "@/src-refactor/modules/shared/model/const/property/trust_entity.const";
import HFormatDate from "@rf-helper/format/format-date";
import { docId } from "@rf/property/module/components/property-form/hooks/helps/usePropertyFormHelp";
import { IPropertyValidationDocument } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";

import { CPropertyValidationDocument } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
const names = CPropertyValidationDocumentKeys;
const prepareValidationToClient = (res: IPropertyDetailsResponse) => {
  if (!Object(res.project).hasOwnProperty("validation_documents")) {
    return CPropertyValidationDocument;
  }

  const documents: { [key: number]: any } = prepareDocumentsInfo(res);
  const aprocovici = getAprocovici(res, documents);
  const confotur = getConfotur(res, documents);
  const trust = getTrust(res, documents);
  const builder = getBuilder(res, documents);
  const objection = getNoObjectionConcejoMunicipal(res, documents);

  return {
    ...CPropertyValidationDocument,
    ...aprocovici,
    ...confotur,
    ...builder,
    ...objection,
    ...trust
  } as IPropertyValidationDocument;
};
export default prepareValidationToClient;

const getAprocovici = (res: IPropertyDetailsResponse, documents: any) => {
  return {
    [names.file_aprocovici]: documents[docId.aprocovici]?.file ?? [],
    [names.file_acoprovi]: documents[docId.acoprovi]?.file ?? [],
    [names.date_file_acoprovi]: documents[docId.acoprovi]?.date ?? "",
    [names.date_file_aprocovici]: documents[docId.aprocovici]?.date ?? "",
    [names.type_association_acoprovi]: documents[docId.aprocovici]?.hasFile
      ? [C_PERTENECE.Aprocovici]
      : [C_PERTENECE.Acoprovi]
  };
};

const getConfotur = (res: IPropertyDetailsResponse, documents: any) => {
  return {
    [names.has_confotur]: res?.project.has_confotur
      ? [O_YES_AND_NOT[res?.project.has_confotur]]
      : [C_YES_AND_NOT.NOT],
    [names.file_previous_mitur]: documents[docId.previous_mitur]?.file ?? [],
    [names.date_file_previous_mitur]: documents[docId.previous_mitur]?.date ?? "",
    [names.file_definitive_confotur]: documents[docId.final_confotur]?.file ?? [],
    [names.date_file_definitive_confotur]:
      documents[docId.final_confotur]?.date ?? ""
  };
};

const getBuilder = (res: IPropertyDetailsResponse, documents: any) => {
  return {
    [names.name_construction_company]: res.project.company_name || "",
    [names.file_rnc_construction]: documents[docId.company_rnc]?.file ?? [],
    [names.rnc_construction]: res.project.company_rnc || "",
    [names.file_assembly_minutes]: documents[docId.company_assembly_act]?.file ?? [],
    [names.file_due_diligence]: documents[docId.enlarged_due_diligence]?.file ?? [],
    [names.file_credit_bureau]: documents[docId.credit_bureau]?.file ?? [],
    [names.file_commercial_register]:
      documents[docId.commercial_register]?.file ?? [],
    [names.file_master_plan]: documents[docId.master_plan]?.file ?? [],
    [names.date_file_commercial_register]:
      documents[docId.commercial_register]?.date ?? "",
    [names.file_construction_cv]:
      documents[docId.construction_company_resume]?.file ?? []
  };
};

const prepareDocumentsInfo = (res: IPropertyDetailsResponse) => {
  if (!Object(res.project).hasOwnProperty("validation_documents")) {
    return [];
  }
  const getFile = (x: any) => {
    if (x.filename) {
      const item = HGenerateFileData({
        file: x.filename
      });
      return item ? [item] : [];
    } else {
      return [];
    }
  };

  const e = res.project.validation_documents.map((x: any) => [
    x.document_type_id,
    {
      date: x.expedition_date ? HFormatDate(x.expedition_date, "form") : "",
      file: getFile(x),
      hasFile: x.filename ? true : false
    }
  ]);

  return Object.fromEntries(e);
};

const getTrust = (res: IPropertyDetailsResponse, documents: any) => {
  return {
    [names.trust_has_trustee]: res?.project.trust_status
      ? A_STATUS_TRUST.filter(x => x.value == res?.project.trust_status)
      : A_STATUS_TRUST.filter(x => x.value == "no"),

    [names.trust_name_trustee]: res?.project.trust_entity_id
      ? [O_TRUST_ENTITY[res?.project.trust_entity_id]]
      : [],

    [names.trust_name_official_trustee]: res.project.trust_officer_name || "",
    [names.trust_email_trustee]: res.project.trust_email || "",
    [names.file_definitive_trustee]: documents[docId.trust]?.file ?? [],
    [names.date_file_definitive_trustee]: documents[docId.trust]?.date ?? "",
    [names.trust_rnc_trustee]: res.project.trust_rnc ?? "",
    [names.file_title_transfer_trustee]:
      documents[docId.trust_transferred_title]?.file ?? [],
    [names.trust_has_meeting_trustee]: res?.project.has_trust_meeting
      ? [O_YES_AND_NOT[res?.project.has_trust_meeting]]
      : [C_YES_AND_NOT.NOT],
    [names.trust_entity_has_meeting_trustee]: res?.project.meeting_trust_entity_id
      ? [O_TRUST_ENTITY[res?.project.meeting_trust_entity_id]]
      : [],
    [names.trust_oficial_name_meeting_trustee]:
      res.project.meeting_officer_name || "",
    [names.trust_date_meeting_trustee]: res.project.trust_meeting_date || "",
    [names.trust_notes_trustee]: res.project.meeting_notes || "",
    [names.trust_estimated_constitution_date]:
      res.project.estimated_trust_formation_date || "",
    [names.file_tax_receipt]: documents[docId.land_transfer_tax]?.file ?? []
  };
};

const getNoObjectionConcejoMunicipal = (
  res: IPropertyDetailsResponse,
  documents: any
) => {
  return {
    [names.date_no_objection_issuance]: documents[docId.no_objection]?.date ?? "",
    [names.file_no_objection_from_town_hall]:
      documents[docId.no_objection]?.file ?? [],
    [names.file_deposit_in_town_hall]:
      documents[docId.deposit_at_town_hall]?.file ?? [],
    [names.date_deposit_town_hall]:
      documents[docId.deposit_at_town_hall]?.date ?? "",

    [names.file_legal_status]: documents[docId.legal_status]?.file ?? [],
    [names.date_file_legal_status]: documents[docId.legal_status]?.date ?? "",

    [names.file_environment]: documents[docId.environment]?.file ?? [],
    [names.date_file_environment]: documents[docId.environment]?.date ?? "",
    [names.file_evidence_earth_movement]: documents[docId.land_movement]?.file ?? [],
    [names.date_file_evidence_earth_movement]:
      documents[docId.land_movement]?.date ?? "",
    [names.file_purchase_sale_land]: documents[docId.land_purchase]?.file ?? [],
    [names.date_file_purchase_sale_land]: documents[docId.land_purchase]?.date ?? "",
    [names.file_construction_license]: documents[docId.building_license]?.file ?? [],
    [names.date_construction_license]: documents[docId.building_license]?.date ?? ""
  };
};
